(() => {
  if (window.__orbitaBuyNowBound) return;
  window.__orbitaBuyNowBound = true;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('[data-orbita-buy-now]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    const details = button.closest('.product-details') || document.querySelector('.product-details');
    const component = details?.querySelector('product-form-component');
    const form = component?.querySelector('form[data-type="add-to-cart-form"]');
    const addToCartButton = component?.querySelector('[ref="addToCartButton"]');

    if (!(form instanceof HTMLFormElement) || addToCartButton?.disabled) return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const variantInput = form.querySelector('input[name="id"]');
    const variantId = variantInput?.value;
    if (!variantId) return;

    const quantityInput = component?.querySelector('input[name="quantity"]');
    const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    const root = window.Shopify?.routes?.root || '/';

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const label = button.querySelector('[data-orbita-buy-now-label]');
    if (label) label.textContent = 'Opening checkout…';

    const checkoutUrl = `${root}cart/${encodeURIComponent(variantId)}:${quantity}`;
    window.location.assign(checkoutUrl);
  });
})();
